import { useQuery } from "react-query";
import authAPI from "../authAPI";

export const useFeideWhitelists = (status = 'active', search = '', options = {}) => {
  return useQuery(
    ["feideWhitelists", status, search],
    async () => {
      const result = await authAPI.getFeideWhitelists(status, search);
      return result;
    },
    {
      ...options,
    }
  );
};
